goog.provide("shadow.js.shim.module$date_fns$locale$lv$default");
shadow.js.shim.module$date_fns$locale$lv$default = esm_import$date_fns$locale$lv.default;
